export function useWorkspaceSchemas() {
  function getWorkspaceSchema() {
    return {
      name: '', // name of workspace
      description: '', // optional

      archived: false, // if is archived or not
      items: [], // lists that are on the workspace
      shared_users: [], // users that have been allowed to view the workspace
      viewed: {}, // tracks users and their last view of the workspace format: {uid: timestamp}

      // standard
      id: null, // unique id of the workspace generated by FS
      created: null, // date the workspace was created fs timestamp
      created_by: null, // user id of the owner of the workspace
      updated: null, // date the workspace was last updated fs timestamp
      updated_by: '' // user id of the last user to edit the workspace
    }
  }

  function getWorkspaceCategorySchema() {
    return {
      name: '', // name of workspace
      items: [], // lists that are on the workspace,
      id: crypto.randomUUID() // unique id of the workspace (for LOCAL use)
    }
  }

  return {
    getWorkspaceSchema,
    getWorkspaceCategorySchema
  }
}
